import type { FC } from 'react';
import { Controller } from 'react-hook-form';
import InputCurrency from '@components/InputCurrency';
import InputSelect from '@components/InputSelect';
import { Show } from '@components/Show';
import { ENDORSEMENT_PREMIUM_CHANGES, ENDORSEMENT_REASONS } from '@domain/endorsements/constants';
import { getConditionalPremiumLabel } from '@helpers/getConditionalPremiumLabel';

import type { StepProps } from '../types';
import { isConditionalPremiumOption } from '../types';

const endorsementReasonOptions = ENDORSEMENT_REASONS.map((value) => ({ name: value, value }));
const endorsementPremiumChangeOptions = ENDORSEMENT_PREMIUM_CHANGES.map((value) => ({ name: value, value }));

export const Step3: FC<StepProps> = ({ control, formValues, isReadOnly = false }) => {
  return (
    <>
      <Controller
        control={control}
        name="reason"
        render={({ field, fieldState: { error } }) => (
          <InputSelect
            {...field}
            isReadOnly={isReadOnly}
            isRequired
            isSearchable
            labelText="Reason"
            options={endorsementReasonOptions}
            errors={error?.message}
            dataTestId="select:endorsement-reason"
            shouldRenderInsidePortal
          />
        )}
      />
      <Controller
        control={control}
        name="premium_change"
        render={({ field, fieldState: { error } }) => (
          <InputSelect
            {...field}
            isReadOnly={isReadOnly}
            isSearchable={false}
            labelText="Premium Change"
            options={endorsementPremiumChangeOptions}
            errors={error?.message}
            dataTestId="select:premium-change"
            shouldRenderInsidePortal
          />
        )}
      />
      <Show when={isConditionalPremiumOption(formValues.premium_change)}>
        <Controller
          control={control}
          name="additional_premium"
          render={({ field, fieldState: { error } }) => (
            <InputCurrency
              {...field}
              isReadOnly={isReadOnly}
              labelText={getConditionalPremiumLabel(formValues.premium_change)}
              isRequired
              value={field.value ?? undefined}
              errors={error?.message}
              dataTestId="currency:additional-premium"
            />
          )}
        />
      </Show>
    </>
  );
};
